<template>
  <f7-page class="page-miner-dashboard">
    <f7-navbar :sliding="false">
      <f7-nav-left>
        <f7-link panel-open="left" icon-f7="menu"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>
        <a @click.prevent="openKTS" class="non-select">KTS - QUẢN LÝ MÁY ĐÀO</a>
      </f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:plus" href="/miner/add-wallet"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-list media-list inset id="miner-list">
      <template v-for="(wallet, idx) in wallets">
        <f7-list-item :key="idx" link="/miner/view-wallet" swipeout :route-props="wallet" :title="wallet.name" :subtitle="`【${capitalizeFirstLetter(wallet.pool)}】${wallet.address}`" @swipeout:deleted="removeWallet(wallet)">
          <img :src="require(`@/assets/crypto-icons/${wallet.coin.toUpperCase()}.png`)" width="44px" slot="media"/>
          <f7-swipeout-actions right>
            <f7-swipeout-button color="orange" @click.prevent="editWallet(wallet)">
              Sửa
            </f7-swipeout-button>
            <f7-swipeout-button color="red" delete>
              Xóa
            </f7-swipeout-button>
          </f7-swipeout-actions>
        </f7-list-item>
      </template>
      <f7-list-item v-if="_.isEmpty(wallets)" title="Chưa có máy đào"></f7-list-item>
    </f7-list>
      <f7-fab position="right-center" slot="fixed" color="red">
        <f7-link href="https://alwaysopeninsafari.com/cskh-kts" external target="_blank">
          <img src="../../assets/images/cskh2.png" style="height: 28px"/>
        </f7-link>
      </f7-fab>
  </f7-page>
</template>
<style>
.list .item-subtitle {
  color : #727272 !important;
}
</style>
<script>
import {
  f7Page,
  f7Navbar,
  f7NavTitle,
  f7NavRight,
  f7Link,
  f7List,
  f7ListItem,
  f7SwipeoutActions,
  f7SwipeoutButton
} from 'framework7-vue';

export default {
  components: {
    f7Page,
    f7Navbar,
    f7NavTitle,
    f7NavRight,
    f7Link,
    f7List,
    f7ListItem,
    f7SwipeoutActions,
    f7SwipeoutButton
  },
  data() {
    return {
      wallets: [],
      clicked: 0,
        navigator: {
            userAgent: "Init"
        },
    }
  },
  methods: {
    editWallet(item) {
      this.$f7router.navigate('/miner/edit-wallet', {
        props: {
          wallet: item
        }
      })
    },
    removeWallet(item) {
      this.$store.dispatch('removeWallet', item);
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    openKTS(){
      if (this.clicked < 10) {
        this.clicked += 1;
        return false;
      }

      this.clicked = 0;
      this.$f7router.navigate('/dashboard');
    }
  },
  mounted() {
      this.navigator = navigator;
    this.$store.dispatch('setDarkMode');
    this.wallets = this.$store.state.wallets;
  }
};
</script>
